module.exports = __webpack_public_path__ + "static/media/line.ffdac49c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/socialMedia/line.svg
// module id = 2317
// module chunks = 0